(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const carouselSection = document.querySelector('[id*="1790444997607549b6"]');
  const reviewWidget = document.getElementById('judgeme_product_reviews');
  if (!carouselSection && !reviewWidget) return;

  let initialBatchExpanded = false;
  let customerInteracted = false;
  if (reviewWidget) reviewWidget.addEventListener('click', (event) => {
    if (event.isTrusted) customerInteracted = true;
  }, true);

  function expandInitialReviewBatch() {
    if (!reviewWidget || initialBatchExpanded || customerInteracted) return;
    const cards = reviewWidget.querySelectorAll('.jm-review-item');
    if (!cards.length) return;
    const button = Array.from(reviewWidget.querySelectorAll('.jm-pagination-controls button'))
      .find((element) => element.textContent.trim() === 'Show more reviews');
    if (!button || button.disabled) return;
    // Fetch a second native page once. Subsequent batches remain customer-controlled.
    initialBatchExpanded = true;
    button.click();
  }

  function refineProductReviewCards() {
    if (!reviewWidget) return;
    const cards = Array.from(reviewWidget.querySelectorAll('.jm-review-item, .jdgm-rev'))
      .filter((card) => !card.closest('.jdgm-legacy-widget-content'));
    cards.forEach((card) => card.classList.add('ph-review-card'));
    const parents = new Set(cards.map((card) => card.parentElement));
    parents.forEach((parent) => {
      if (parent && cards.filter((card) => card.parentElement === parent).length > 1) {
        parent.classList.add('ph-review-card-grid');
      }
    });

    // An empty media carousel can leave a large blank area and a disabled arrow above the reviews.
    const firstCard = cards[0];
    if (!firstCard) return;
    reviewWidget.querySelectorAll('[class*="gallery"], [class*="carousel"]').forEach((gallery) => {
      if (gallery.contains(firstCard) || gallery.querySelector('img, video, picture, [style*="background-image"]')) return;
      if (!gallery.querySelector('button, [role="button"]')) return;
      const bounds = gallery.getBoundingClientRect();
      const firstBounds = firstCard.getBoundingClientRect();
      if (bounds.height > 60 && bounds.bottom <= firstBounds.top + 5) gallery.classList.add('ph-review-empty-gallery');
    });
  }

  function refineProductReviewHeadingAndGap() {
    if (!reviewWidget) return;
    const title = Array.from(reviewWidget.querySelectorAll('h1, h2, h3, [role="heading"], div, span, p'))
      .find((element) => !element.closest('.jdgm-legacy-widget-content') &&
        ['Customer Reviews', 'Customer Reviews For This Print'].includes(element.textContent.trim()) &&
        !Array.from(element.children).some((child) => child.textContent.trim() === element.textContent.trim()));
    if (!title) return;
    if (title.textContent.trim() === 'Customer Reviews') title.textContent = 'Customer Reviews For This Print';

  }

  function wrapMobileHeading(carousel) {
    const headingText = 'See what our customers say';
    const candidates = Array.from(carousel.querySelectorAll('h1, h2, h3, div, span, p'));
    const leaf = candidates.find((el) => el.textContent.trim() === headingText && !Array.from(el.children).some((child) => child.textContent.trim() === headingText));
    for (let el = leaf; el && el !== carousel && el.textContent.trim() === headingText; el = el.parentElement) {
      el.style.setProperty('white-space', 'normal', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('text-overflow', 'clip', 'important');
      el.style.setProperty('-webkit-line-clamp', 'unset', 'important');
      el.style.setProperty('max-width', '100%', 'important');
    }
  }

  function updateMobileCarousel() {
    if (!carouselSection || !mobile.matches) return;
    const carousel = carouselSection.querySelector('.jdgm-cards-carousel');
    if (!carousel) return;
    wrapMobileHeading(carouselSection);

    const slideSelectors = [
      '[aria-roledescription="slide"]',
      '.swiper-slide',
      '[class*="embla__slide"]',
      '[class*="carousel__slide"]',
      '[class*="carousel-item"]',
      '[class*="review-card"]',
      '.jm-review-item'
    ];
    const cards = slideSelectors
      .map((selector) => Array.from(carousel.querySelectorAll(selector)))
      .find((items) => items.length >= 2 && items.length <= 30) || [];
    if (cards.length < 2) return;
    let indicator = carouselSection.querySelector('.ph-mobile-review-pagination');
    if (!indicator) {
      indicator = document.createElement('span');
      indicator.className = 'ph-mobile-review-pagination';
      indicator.setAttribute('role', 'status');
      indicator.setAttribute('aria-live', 'polite');
    }

    const buttons = Array.from(carousel.querySelectorAll('button, [role="button"]'));
    const buttonName = (button) => [button.getAttribute('aria-label'), button.getAttribute('title'), button.className].filter((value) => typeof value === 'string').join(' ');
    let previous = buttons.find((button) => /previous|prev/i.test(buttonName(button)));
    let next = buttons.find((button) => /next/i.test(buttonName(button)));
    if (!previous || !next) {
      const bottom = buttons.filter((button) => {
        const rect = button.getBoundingClientRect();
        const area = carousel.getBoundingClientRect();
        return rect.width > 0 && rect.width <= 70 && rect.top >= area.bottom - 120;
      }).sort((a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left);
      if (bottom.length === 2) [previous, next] = bottom;
    }
    let nav = previous?.parentElement;
    while (nav && !nav.contains(next)) nav = nav.parentElement;
    if (nav && nav !== carousel && nav.querySelectorAll('button, [role="button"]').length <= 4) {
      nav.classList.add('ph-mobile-review-nav');
      if (indicator.parentElement !== nav) {
        let nextSlot = next;
        while (nextSlot.parentElement !== nav) nextSlot = nextSlot.parentElement;
        nav.insertBefore(indicator, nextSlot);
      }
    } else if (indicator.parentElement !== carousel.parentElement) {
      carousel.after(indicator);
    }

    const area = carousel.getBoundingClientRect();
    const centre = area.left + area.width / 2;
    const distances = cards.map((card) => {
      const rect = card.getBoundingClientRect();
      return rect.right > area.left && rect.left < area.right
        ? Math.abs(rect.left + rect.width / 2 - centre)
        : Number.POSITIVE_INFINITY;
    });
    const nearest = distances.indexOf(Math.min(...distances));
    const current = nearest >= 0 && Number.isFinite(distances[nearest]) ? nearest + 1 : 1;
    const labelledSlide = cards[nearest]?.getAttribute('aria-label') || '';
    const labelledCount = labelledSlide.match(/(?:\d+)\s*(?:\/|of)\s*(\d+)/i);
    const total = labelledCount ? Number(labelledCount[1]) : cards.length;
    const value = `${current} / ${total}`;
    if (indicator.textContent !== value) indicator.textContent = value;
  }

  if (reviewWidget) {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        refineProductReviewCards();
        refineProductReviewHeadingAndGap();
        expandInitialReviewBatch();
      });
    }).observe(reviewWidget, { childList: true, subtree: true });
  }

  let checks = 0;
  const startup = setInterval(() => {
    expandInitialReviewBatch();
    refineProductReviewCards();
    refineProductReviewHeadingAndGap();
    updateMobileCarousel();
    if (++checks >= 30) clearInterval(startup);
  }, 500);
  document.addEventListener('DOMContentLoaded', () => {
    expandInitialReviewBatch();
    refineProductReviewCards();
    refineProductReviewHeadingAndGap();
    updateMobileCarousel();
  });
  if (carouselSection) setInterval(updateMobileCarousel, 1000);
  if (reviewWidget) window.addEventListener('resize', refineProductReviewHeadingAndGap);
})();
